import type { AuthApi } from '../../features/auth/data/auth-api';
import { Auth } from './auth';

let pendingRefresh: Promise<string | null> | null = null;

/**
 * Single-flights concurrent refresh attempts. The backend rotates and revokes the
 * refresh token on every use, so two concurrent calls racing with the same token
 * would knock each other's session out — every caller must share one in-flight call.
 */
export function refreshAccessToken(authApi: AuthApi, auth: Auth): Promise<string | null> {
  if (pendingRefresh) {
    return pendingRefresh;
  }

  const refreshToken = auth.getRefreshToken();
  if (!refreshToken) {
    return Promise.resolve(null);
  }

  pendingRefresh = authApi
    .refreshAccessToken(refreshToken)
    .then((response) => {
      auth.storeTokens(response);
      return response.accessToken;
    })
    .catch(() => {
      auth.clearSession();
      return null;
    })
    .finally(() => {
      pendingRefresh = null;
    });

  return pendingRefresh;
}
